import { gql } from "@apollo/client"

const GET_MENUS = gql`
  query FetchMenus($desktopMenu: String!, $culture: String!) {
    menu_desktop: contentByAbsoluteRoute(
      route: $desktopMenu
      culture: $culture
    ) {
      ...menuContentNested
    }
  }

  fragment menuContentNested on BasicContent {
    ...menuContent
    children {
      ...menuContent
      children {
        ...menuContent
        children {
          ...menuContent
        }
      }
    }
  }

  fragment menuContent on BasicContent {
    #name
    properties {
      property: value {
        ...menuBasicValue
        ...menuContentPicker
      }
    }
  }

  fragment menuBasicValue on PropertyValue {
    ... on BasicPropertyValue {
      menuName: value
    }
  }

  fragment menuContentPicker on PropertyValue {
    ... on BasicContentPicker {
      menuTarget: contentList {
        id
        absoluteUrl
        key
        name
        url
        urlSegment
      }
    }
  }
`

export default GET_MENUS
